import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import Login from './pages/Login';
import AuthCallback from './pages/AuthCallback';
import { DemoDashboard, DemoSubscription, DemoBilling, DemoSecurityStatus, DemoDarkWeb, DemoVulnerability, DemoEmailSecurity, DemoCompany, DemoContacts, DemoSupport, DemoProjects, DemoResources } from './pages/DemoPages';
import CustomerDashboard from './pages/customer/Dashboard';
import MySubscription from './pages/customer/MySubscription';
import Billing from './pages/customer/Billing';
import CyberScore from './pages/customer/CyberScore';
import SecurityStatus from './pages/customer/SecurityStatus';
import CompanyDetails from './pages/customer/CompanyDetails';
import Contacts from './pages/customer/Contacts';
import Tickets from './pages/customer/Tickets';
import Support from './pages/customer/Support';
import Resources from './pages/customer/Resources';
import Projects from './pages/customer/Projects';
import AdminDashboard from './pages/admin/Dashboard';
import AdminCustomers from './pages/admin/Customers';
import AdminSubscriptions from './pages/admin/Subscriptions';
import SubscriptionDetail from './pages/admin/SubscriptionDetail';
import AdminCyberScores from './pages/admin/CyberScores';
import AdminSecurityStatus from './pages/admin/SecurityStatus';
import AdminTickets from './pages/admin/Tickets';
import AdminResources from './pages/admin/Resources';
import AdminInvoices from './pages/admin/Invoices';
import AdminProjects from './pages/admin/Projects';
import ZohoDeskAdmin from './pages/admin/ZohoDeskAdmin';
import XeroBillingAdmin from './pages/admin/XeroBillingAdmin';
import AdminUsers from './pages/admin/Users';
import AccountManagers from './pages/admin/AccountManagers';
import DarkWebMonitoring from './pages/customer/DarkWebMonitoring';
import VulnerabilityScanning from './pages/customer/VulnerabilityScanning';
import EmailSecurityPosture from './pages/customer/EmailSecurityPosture';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';

function AppRouter() {
  const location = useLocation();
  // Check for session_id in hash or query params
  if (location.hash?.includes('session_id=') || location.search?.includes('session_id=') || window.location.href.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/demo" element={<DemoDashboard />} />
      <Route path="/demo/subscription" element={<DemoSubscription />} />
      <Route path="/demo/billing" element={<DemoBilling />} />
      <Route path="/demo/security-status" element={<DemoSecurityStatus />} />
      <Route path="/demo/dark-web" element={<DemoDarkWeb />} />
      <Route path="/demo/vulnerability" element={<DemoVulnerability />} />
      <Route path="/demo/email-security" element={<DemoEmailSecurity />} />
      <Route path="/demo/company" element={<DemoCompany />} />
      <Route path="/demo/contacts" element={<DemoContacts />} />
      <Route path="/demo/support" element={<DemoSupport />} />
      <Route path="/demo/projects" element={<DemoProjects />} />
      <Route path="/demo/resources" element={<DemoResources />} />
      <Route path="/dashboard" element={<ProtectedRoute><CustomerDashboard /></ProtectedRoute>} />
      <Route path="/subscription" element={<ProtectedRoute><MySubscription /></ProtectedRoute>} />
      <Route path="/billing" element={<ProtectedRoute><Billing /></ProtectedRoute>} />
      <Route path="/cyber-score" element={<ProtectedRoute><CyberScore /></ProtectedRoute>} />
      <Route path="/security-status" element={<ProtectedRoute><SecurityStatus /></ProtectedRoute>} />
      <Route path="/company" element={<ProtectedRoute><CompanyDetails /></ProtectedRoute>} />
      <Route path="/contacts" element={<ProtectedRoute><Contacts /></ProtectedRoute>} />
      <Route path="/tickets" element={<ProtectedRoute><Tickets /></ProtectedRoute>} />
      <Route path="/support" element={<ProtectedRoute><Support /></ProtectedRoute>} />
      <Route path="/resources" element={<ProtectedRoute><Resources /></ProtectedRoute>} />
      <Route path="/dark-web-monitoring" element={<ProtectedRoute><DarkWebMonitoring /></ProtectedRoute>} />
      <Route path="/vulnerability-scanning" element={<ProtectedRoute><VulnerabilityScanning /></ProtectedRoute>} />
      <Route path="/email-security" element={<ProtectedRoute><EmailSecurityPosture /></ProtectedRoute>} />
      <Route path="/admin/dashboard" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
      <Route path="/admin/customers" element={<AdminRoute><AdminCustomers /></AdminRoute>} />
      <Route path="/admin/subscriptions" element={<AdminRoute><AdminSubscriptions /></AdminRoute>} />
      <Route path="/admin/subscriptions/:subscriptionId" element={<AdminRoute><SubscriptionDetail /></AdminRoute>} />
      <Route path="/admin/cyber-scores" element={<AdminRoute><AdminCyberScores /></AdminRoute>} />
      <Route path="/admin/security-status" element={<AdminRoute><AdminSecurityStatus /></AdminRoute>} />
      <Route path="/admin/tickets" element={<AdminRoute><AdminTickets /></AdminRoute>} />
      <Route path="/admin/support" element={<AdminRoute><ZohoDeskAdmin /></AdminRoute>} />
      <Route path="/admin/resources" element={<AdminRoute><AdminResources /></AdminRoute>} />
      <Route path="/admin/invoices" element={<AdminRoute><AdminInvoices /></AdminRoute>} />
      <Route path="/admin/projects" element={<AdminRoute><AdminProjects /></AdminRoute>} />
      <Route path="/admin/billing" element={<AdminRoute><XeroBillingAdmin /></AdminRoute>} />
      <Route path="/admin/users" element={<AdminRoute><AdminUsers /></AdminRoute>} />
      <Route path="/admin/account-managers" element={<AdminRoute><AccountManagers /></AdminRoute>} />
      <Route path="/projects" element={<ProtectedRoute><Projects /></ProtectedRoute>} />
      <Route path="/" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster position="top-right" theme="dark" />
    </div>
  );
}

export default App;